module.exports = __webpack_public_path__ + "img/vokabox-icon.965e1545.png";